import React, { useState, useEffect } from 'react'
import { BlockingLoader, Popup } from '@pmi/pmi-iqos-ds-react'
import { ProductBundleDetailView } from '@dcx-common/components'

const ProductBundleModal = ({
  bundle,
  handleAddToCart,
  isOpen,
  onCloseHandler,
  translations,
  bundleDetailPath
}) => {
  const [loading, setLoading] = useState(false)
  const [currentBundle, setCurrentBundle] = useState(bundle)

  useEffect(() => {
    if (bundle !== currentBundle) {
      setCurrentBundle(bundle)
    }
  }, [bundle])

  const addToCart = async items => {
    setLoading(true)
    try {
      handleAddToCart && (await handleAddToCart(items))
    } finally {
      setLoading(false)
    }
  }

  return (
    <Popup isOpen={isOpen} onCloseHandler={onCloseHandler} fullScreen>
      <>
        {currentBundle && (
          <ProductBundleDetailView
            bundle={currentBundle}
            translations={translations}
            handleAddToCart={addToCart}
            loading
            bundleDetailPath={bundleDetailPath}
          />
        )}
      </>
      <BlockingLoader zIndex="2" loading={loading} />
    </Popup>
  )
}

export default ProductBundleModal
